export const LegalEntities = {
  en: {
    'Legal Entities': 'Legal Entities',
    'Create Legal Entity': 'Create Legal Entity',
  },
  uk: {
    'Legal Entities': 'Юридичні особи',
    'Create Legal Entity': 'Створити юридичну особу',
  },
};

export const LegalEntityForm = {
  en: {
    ...LegalEntities.en,
    'New Legal Entity': 'New Legal Entity',
    'Edit Legal Entity': 'Edit Legal Entity',
    'Update Legal Entity': 'Update Legal Entity',
  },
  uk: {
    ...LegalEntities.uk,
    'New Legal Entity': 'Нова юридична особа',
    'Edit Legal Entity': 'Редагування юридичної особи',
    'Update Legal Entity': 'Оновити юридичну особу',
  },
};
